import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=51f7ae44&scoped=true&"
import script from "./CustomPagination.vue?vue&type=script&lang=ts&"
export * from "./CustomPagination.vue?vue&type=script&lang=ts&"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=51f7ae44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7ae44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
